module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("会员申请")]), _vm._m(0), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("立即申请"), _c('div', {
    staticClass: "triangle-right"
  })])])])]), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "container"
  }, [_vm._m(4), _c('div', {
    staticClass: "recommender-list"
  }, [_c('ul', _vm._l((_vm.recommender.items), function(item, $index) {
    return _c('li', {
      staticClass: "recommender-item"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "company"
    }, [_vm._v(_vm._s(item.company))]), _c('p', {
      staticClass: "position",
      domProps: {
        "innerHTML": _vm._s(item.position)
      }
    })])
  }), 0)]), _c('div', {
    staticClass: "tips"
  }, [_vm._v("* 除以上推荐人外前沿社会员也具备推荐资格")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "observer-tip"
  }, [_c('p', [_vm._v("「前沿社」是由极客公园发起创立的企业家社群"), _c('br'), _vm._v("通过「近场研究FIELD STUDY」、「前沿工作坊FRONTIER WORKSHOP」、「超频之旅OVERCLOCKING TRIP」三大板块"), _c('br'), _vm._v("帮助企业家把握技术潮流、连接产业前沿及保持创新思维"), _c('br'), _vm._v("以最有效率的方式，让最优秀的企业家与全球顶尖科学家、科技研究者一起迭代进步。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("CONDITIONS OF ENTRY")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("申请条件")])]), _c('div', {
    staticClass: "entry-list special"
  }, [_c('ul', [_c('li', [_c('b', [_vm._v("推　荐：")]), _vm._v("每位申请人需要被一位前沿社会员或行业领军人物推荐")]), _c('li', [_c('b', [_vm._v("资　格：")]), _vm._v("申请人须为企业创始人、联合创始人；企业高管包括 CEO、CTO 或 COO")]), _c('li', [_c('b', [_vm._v("审　核：")]), _vm._v("前沿社联合发起人享有最终会员资格审核权")]), _c('li', [_c('b', [_vm._v("会员费：")]), _vm._v("10 万人民币/年")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("MEMBERSHIP BENEFITS")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("会员权益")])]), _c('div', {
    staticClass: "entry-list"
  }, [_c('ul', [_c('li', [_vm._v("与全球 TOP20 知名学府、科研机构权威专家交流资格*")]), _c('li', [_vm._v("可报名全年的近场研究Field Study 闭门交流")]), _c('li', [_vm._v("优先参与极客公园主办的海外超频之旅活动，享受优惠*")]), _c('li', [_vm._v("免费参与前沿社组织的其他高端闭门交流机会")])]), _c('p', {
    staticClass: "notes"
  }, [_vm._v("* 将根据Membership权益不同略有调整")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("SCHOLARSHIP APPLICATION")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("奖学金申请")])]), _c('div', {
    staticClass: "entry-list"
  }, [_c('ul', [_c('li', [_vm._v("前沿社对早期创业公司特设奖学金机制")]), _c('li', [_vm._v("经过机构推荐，B轮之前阶段优秀公司创始人可申请前沿社奖学金")]), _c('li', [_vm._v("经过评审考核，前沿社将给予价值7万元的专项奖学金")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("RECOMMENDER")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("推荐人")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05f7ce46!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Entry.vue
// module id = 187
// module chunks = 1